import type { batchDetail } from '@/types/dashboard';

export interface GradeWiseStudentCount {
  grade_id: number;
  student_count: number;
}

export interface SchoolDetailsResponse {
  school_id: string;
  school_code: string;
  school_name: string;
  school_type?: string;
  udise_code?: string;
  address?: string;
  city_id?: number;
  state_id?: number;
  country_id?: number;
  district_name?: string;
  area?: string | null;
  postal_code?: string;
  board_ids?: number[];
  total_student_count?: number;
  total_teacher_count?: number;
  fee?: string;
  tier_id?: number;
  poc_id?: number;
  status?: number;
  grade_wise_student_count?: GradeWiseStudentCount[];
}

export interface SearchSchoolData {
  schools: SchoolDetailsResponse[];
  total_count: number;
  total_pages: number;
  page_size: number;
  page: number;
}

export interface SchoolDetails {
  id: string;
  name: string;
  address: string;
  districtName: string;
  totalStudentCount: number;
  totalTeacherCount: number;
}

export function toSchoolDetails(raw: SchoolDetailsResponse): SchoolDetails {
  return {
    id: raw.school_id,
    name: raw.school_name,
    address: raw.address ?? '',
    districtName: raw.district_name ?? '',
    totalStudentCount: raw.total_student_count ?? 0,
    totalTeacherCount: raw.total_teacher_count ?? 0,
  };
}

export interface generateSchoolReportPayload{
  batch_ids: string[];
  exam_date: string;
}

export interface generateMagicLinkReportPayload {
  batch_ids: string[];
}

export interface SchoolStudentResponse {
  first_name: string;
  last_name: string;
  phone: string;
  grade: number;
  username: string | null;
  user_id: number;
  is_logged_in: boolean;
  last_logged_in_time: string | null;
}

export interface SchoolStudentsResponse {
  students: SchoolStudentResponse[];
}

export interface Student {
  userId: number;
  firstName: string;
  lastName: string;
  fullName: string;
  phone: string;
  grade: number;
  username: string | null;
  isLoggedIn: boolean;
  lastLoggedInTime: string | null;
}

export function toSchoolStudent(raw: SchoolStudentResponse): Student {
  return {
    userId: raw.user_id,
    firstName: raw.first_name,
    lastName: raw.last_name,
    fullName: [raw.first_name, raw.last_name].filter(Boolean).join(' ').trim(),
    phone: raw.phone,
    grade: raw.grade,
    username: raw.username,
    isLoggedIn: raw.is_logged_in,
    lastLoggedInTime: raw.last_logged_in_time,
  };
}

export function toSchoolStudents(raw: SchoolStudentsResponse): Student[] {
  return raw.students.map(toSchoolStudent);
}

export interface ExportReportResponse {
  message: string;
  file_url: string;
}

export interface SchoolBatchResponse {
  id: string;
  name: string;
  display_name: string;
}

export interface SchoolBatchesResponse {
  batches: SchoolBatchResponse[];
}

export function toSchoolBatch(raw: SchoolBatchResponse): batchDetail {
  return {
    id: raw.id,
    name: raw.name,
    displayName: raw.display_name,
  };
}

export function toSchoolBatches(raw: SchoolBatchesResponse): batchDetail[] {
  return (raw.batches ?? []).map(toSchoolBatch);
}
